<template>
  <Modal :id="'cmp-distribution-suppliers-new_supplier'" @cancelled="onCancel">
    <template slot="header">{{
      $dft.snakeCaseToWords("new_supplier")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'supplier_name'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="supplier_name"
            isModel
            :placeholder="$t('Supplier')"
            @valuechanged="onTextFieldValueChange"
            required
            showValidationIcons
            @validated="onValidation"
          />
          <Dropdown
            :id="'supply_order_type'"
            class="m2"
            :options="supplier_typeTV"
            :selected="
              supplier_typeTV.find((b) => b.value == supply_order_type)
            "
            :placeholder="$t('type')"
            deselect
            box
            @selectedChange="(b) => onDropdownChange('supply_order_type', b)"
          ></Dropdown>
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        class="dt-button v1 s6"
        @click.stop="onSave"
      >
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from "../../../../plugins/text-field";
import { SuppliersService } from "../../services/suppliers.service";

export default {
  components: {
    Modal,
    TextField,
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      supplier_name: null,
      supply_order_type: null,
      supply_order_type_name: null,
      validationResult: {},
    };
  },
  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    supplier_typeTV: function () {
      return [
        { text: "Manufacturing", value: 1 },
        { text: "Purchase Order", value: 2 },
        { text: "Purchase Return", value: 3 },
        { text: "Defects Credit", value: 4 },
        { text: "Consignment", value: 5 },
        { text: "Consignment Return", value: 6 },
        { text: "Defects Consignment", value: 7 },
      ];
    },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onTextFieldValueChange: function (name, value) {
      this.supplier_name = value;
    },
    onDropdownChange: function (name, value) {
      this.supply_order_type = value.value;
      this.supply_order_type_name = value.text;
    },
    onSave: async function () {
      const res = await SuppliersService.addNewSupplier(
        this.supplier_name,
        this.supply_order_type
      );
      console.log("res", res);
      this.$emit("added", {
        ...res.data,
        supplier_name: this.supplier_name,
        supply_order_type_name: this.supply_order_type_name,
        supply_order_type: this.supply_order_type,
      });
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style></style>
